import { StepType } from 'src/app/shared/shared.module';
import {
    getInputField, setAsRequired, setRegexValidation,
    getSelectField, getTypeAheadField, getDateField, MinMaxAgeMustBe,setDisableWhen,setRequiredWhen
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';
import { map } from 'rxjs/operators';

export class ExitIqamaTransfer extends VisaType {


    GetRequesterSteps(operations?: () => string[]): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          this.EmpProfileSearch(null, operations),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.gpn(),
                            this.gui(),
                           // this.gpnGuiSearchButton(operations)
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nationalityTypeWithSpecialExpact(),  
                            this.nationality(),
                            getInputField("passportNumber", "Passport number",
                                this.addFieldTooltipWithAdditionalConfig('Passport number')
                            ),
                            getSelectField(
                                "serviceLine.id",
                                "Service line",
                                this.common.getSelectFieldOptions(this.serviceLines$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "subServiceLine.id",
                                "Sub-service line",
                                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                                    setAsRequired())
                            ),
                            this.rank(),
                        //   this.grade(),
                            getSelectField(
                                "officeToBeVisited.id",
                                "Office location",
                                this.common.getSelectFieldOptions(this.officeLocation$, '', setAsRequired(this.addFieldTooltipWithAdditionalConfig('Office location')
                            ))
                            ),
                            this.officeLE('EY legal entity'),

                        ]
                    }]
            },
            {
                label: "Step 2",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.lastWorkingDay(),
                            getSelectField(
                                "cancellationReason.id",
                                "Reason for exit",
                                this.common.getSelectFieldOptions(this.cancellationReason$, '',
                                    setAsRequired())
                            ),
                            getInputField(
                                "otherReasonForCancellation",
                                "Other Reason For exit",
                                setDisableWhen((model) => !isNullOrUndefined(model.cancellationReason) && model.cancellationReason.id !== 12150,
                                setRequiredWhen((model) => !isNullOrUndefined(model.cancellationReason) && model.cancellationReason.id === 12150))
                                ) ,
                                getInputField(
                                    "nameOfNewEmployer",
                                    "Name of new employer"
                                ),    
                                this.iqamaNumber(),
                                this.RequestorName()

                        ]
                    }
                ]
            },

        ];

    }


    GetAccepterSteps(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                          this.visaProcessorByOfficeLE(setAsRequired()),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }



    GetApproverSteps(): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            // this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.dateOfBirthOptional(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            this.visaProcessorByOfficeLE(
                                setAsRequired()
                                ),
                          this.immigrationStatus(),
                        //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }

}
